module.exports = __webpack_public_path__ + "assets/icons/testproject.3cec74f508c28353d10a20355c775896.svg";